import { LeadActivityEvent } from '@spike/client-model';

const LEAD_ACTIVITY_LABELS: Readonly<Record<LeadActivityEvent, string>> = {
    [LeadActivityEvent.LeadCreated]: 'Lead created',
    [LeadActivityEvent.StageChanged]: 'Stage changed',
    [LeadActivityEvent.FirstContacted]: 'First contacted',
    [LeadActivityEvent.SmsSent]: 'SMS sent',
    [LeadActivityEvent.EmailSent]: 'Email sent',
    [LeadActivityEvent.FormSent]: 'Form sent',
    [LeadActivityEvent.FormCompleted]: 'Form completed',
    [LeadActivityEvent.PetAdded]: 'Pet added',
    [LeadActivityEvent.AppointmentBooked]: 'Appointment booked',
    [LeadActivityEvent.AppointmentCanceled]: 'Appointment canceled',
    [LeadActivityEvent.NoteAdded]: 'Note added',
    [LeadActivityEvent.MarkedAsLost]: 'Marked as Lost',
    [LeadActivityEvent.ConvertedToClient]: 'Converted to Client'
};

const isKnownLeadActivityEvent = (event: string): event is LeadActivityEvent =>
    Object.prototype.hasOwnProperty.call(LEAD_ACTIVITY_LABELS, event);

const humanizeLeadActivityEvent = (event: string): string => {
    const spaced = event.replace(/_/g, ' ').trim();
    return spaced.length === 0 ? '' : spaced.charAt(0).toUpperCase() + spaced.slice(1);
};

export const getLeadActivityLabel = (event: string): string =>
    isKnownLeadActivityEvent(event) ? LEAD_ACTIVITY_LABELS[event] : humanizeLeadActivityEvent(event);
